import {
  //
  ROLE_REQUEST,
  ROLE_SUCCESS,
  ROLE_FAIL,
  ROLE_CLEAR_ERRORS,
  //
  COMPANY_REQUEST,
  COMPANY_SUCCESS,
  COMPANY_FAIL,
  COMPANY_CLEAR_ERRORS,
  //
  MARKET_SHARE_REQUEST,
  MARKET_SHARE_SUCCESS,
  MARKET_SHARE_FAIL,
  MARKET_SHARE_CLEAR_ERRORS,
  //
  INDUSTRY_REQUEST,
  INDUSTRY_SUCCESS,
  INDUSTRY_FAIL,
  INDUSTRY_CLEAR_ERRORS,
  //
  ANNUAL_REVENUE_REQUEST,
  ANNUAL_REVENUE_SUCCESS,
  ANNUAL_REVENUE_FAIL,
  ANNUAL_REVENUE_CLEAR_ERRORS,
  //
  TOTAL_HEAD_COUNT_REQUEST,
  TOTAL_HEAD_COUNT_SUCCESS,
  TOTAL_HEAD_COUNT_FAIL,
  TOTAL_HEAD_COUNT_CLEAR_ERRORS,
} from "../Constants/company_constants";

// role
export const role_reducer = (
  state = {
    role: [],
  },
  action
) => {
  switch (action.type) {
    case ROLE_REQUEST:
      return {
        loading: true,
        role: [],
      };
    case ROLE_SUCCESS:
      return {
        loading: false,
        role: action.payload.data,
      };
    case ROLE_FAIL:
      return {
        loading: false,
        role: null,
        role_error: action.payload,
      };

    case ROLE_CLEAR_ERRORS:
      return {
        ...state,
        role_error: null,
      };
    default:
      return state;
  }
};
// company

export const company_reducer = (
  state = {
    company: [],
  },
  action
) => {
  switch (action.type) {
    case COMPANY_REQUEST:
      return {
        loading: true,
        company: [],
      };
    case COMPANY_SUCCESS:
      return {
        loading: false,
        company: action.payload.data,
      };
    case COMPANY_FAIL:
      return {
        loading: false,
        company_error: action.payload,
      };

    case COMPANY_CLEAR_ERRORS:
      return {
        ...state,
        company_error: null,
      };
    default:
      return state;
  }
};

// market share

export const market_share_reducer = (
  state = {
    market_share: [],
  },
  action
) => {
  switch (action.type) {
    case MARKET_SHARE_REQUEST:
      return {
        loading: true,
        market_share: [],
      };
    case MARKET_SHARE_SUCCESS:
      return {
        loading: false,
        market_share: action.payload.data,
      };
    case MARKET_SHARE_FAIL:
      return {
        loading: false,
        role: null,
        market_share_error: action.payload,
      };

    case MARKET_SHARE_CLEAR_ERRORS:
      return {
        ...state,
        market_share_error: null,
      };
    default:
      return state;
  }
};

// Industry
export const industry_reducer = (
  state = {
    industry_type: [],
  },
  action
) => {
  switch (action.type) {
    case INDUSTRY_REQUEST:
      return {
        loading: true,
        industry_type: [],
      };
    case INDUSTRY_SUCCESS:
      return {
        loading: false,
        industry_type: action.payload.data,
      };
    case INDUSTRY_FAIL:
      return {
        loading: false,
        role: null,
        industry_error: action.payload,
      };

    case INDUSTRY_CLEAR_ERRORS:
      return {
        ...state,
        industry_error: null,
      };
    default:
      return state;
  }
};

// Annual Revenue
export const annual_revenue_reducer = (
  state = {
    annual_revenue: [],
  },
  action
) => {
  switch (action.type) {
    case ANNUAL_REVENUE_REQUEST:
      return {
        loading: true,
        annual_revenue: [],
      };
    case ANNUAL_REVENUE_SUCCESS:
      return {
        loading: false,
        annual_revenue: action.payload.data,
      };
    case ANNUAL_REVENUE_FAIL:
      return {
        loading: false,
        role: null,
        annual_revenue_error: action.payload,
      };

    case ANNUAL_REVENUE_CLEAR_ERRORS:
      return {
        ...state,
        annual_revenue_error: null,
      };
    default:
      return state;
  }
};

// total head count
export const total_head_count_reducer = (
  state = {
    total_head_count: [],
  },
  action
) => {
  switch (action.type) {
    case TOTAL_HEAD_COUNT_REQUEST:
      return {
        loading: true,
        total_head_count: [],
      };
    case TOTAL_HEAD_COUNT_SUCCESS:
      return {
        loading: false,
        total_head_count: action.payload.data,
      };
    case TOTAL_HEAD_COUNT_FAIL:
      return {
        loading: false,
        role: null,
        total_head_count_error: action.payload,
      };

    case TOTAL_HEAD_COUNT_CLEAR_ERRORS:
      return {
        ...state,
        total_head_count_error: null,
      };
    default:
      return state;
  }
};
